// extracted by mini-css-extract-plugin
export default {"avatar":"A_UserAvatar_avatar__-Qwwi","link":"A_UserAvatar_link__E9cwO","hasBorder":"A_UserAvatar_hasBorder__0PfRC"};